import { userController } from "../api";
import { useCompany } from "../hooks/company";
import { useRequest } from "ahooks";
import { flatDepartment } from "../utils";
import { Descriptions, Modal, Spin } from "antd";
import { AvatarImg } from "./OSSImage";
import { useEffect } from "react";
import dayjs from "dayjs";

export const UserModal = ({
  id,
  name,
  open,
  onCancel,
}: {
  id: I.ID;
  name: string;
  open?: boolean;
  onCancel: () => void;
}) => {
  const { id: companyId, allDepartments: departments } = useCompany();

  const {
    data: user,
    loading,
    run: loadUser,
  } = useRequest(
    () => {
      return userController.get(companyId, id).then((data) => {
        return {
          ...data,
          department: flatDepartment(departments, data.departmentId)
            .map(({ name }) => name)
            .reverse()
            .join('/'),
        };
      });
    },
    {
      refreshDeps: [companyId, id],
      manual: true,
    },
  );

  useEffect(() => {
    if (open) {
      loadUser();
    }
  }, [open]);

  return (
    <Modal
      title={name}
      open={open}
      onCancel={onCancel}
      width={300}
      footer={false}
    >
      <Spin spinning={loading}>
        <Descriptions column={1}>
          <Descriptions.Item children={<AvatarImg userId={id} size={100} />} />
          <Descriptions.Item label="工号" children={id} />
          <Descriptions.Item label="姓名" children={user?.name} />
          <Descriptions.Item label="区域" children={user?.department} />
          <Descriptions.Item
            label="加入时间"
            children={dayjs(user?.createdAt).format('YYYY-MM-DD')}
          />
        </Descriptions>
      </Spin>
    </Modal>
  );
};

export default UserModal;
